import headerScrollWhite from '../partials/headerWhite';
import threeColumnSliderInit from '../partials/three-column-slider';

export default {
  init() {
    window.onscroll = headerScrollWhite;
    threeColumnSliderInit();
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/regulationPage.js